module.exports = __webpack_public_path__ + "img/homepage-bg.0c1bdd92.jpg";